import { FC } from 'react'
import { Collapse, CollapsePanelProps } from 'antd'
import classnames from 'classnames'

import style from './style.m.less'
import { Down } from '../../../../assets/icons'

const { Panel: AntPanel } = Collapse

const SubPanel: FC<CollapsePanelProps> = (props) => {
    const realHeader = (
        <div className={classnames(style.header, { [style.active]: (props as any).isActive })}>
            {props.header}
            <span className={style.icon}>
                <Down />
            </span>
        </div>
    )
    return (
        <AntPanel
            showArrow={false}
            {...props}
            header={realHeader}
            className={classnames(style.panel, (props as any).className)}
        />
    )
}

export default SubPanel
